import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { SideMenu, BackHeader } from "./../../components";
import Date from "./../../../data/date";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import ContemporaryImage from "./../../../assets/images/Contemporary.png";
import ClassicImage from "./../../../assets/images/Classic.png";
import ModernImage from "./../../../assets/images/Modern.png";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { BsPlusLg } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
const Input = styled("input")({
  display: "none",
});
const label = { inputProps: { "aria-label": "Checkbox demo" } };
let InvoiceSetting = (props) => {
  const navigate = useNavigate();
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <div className="data-view-card-main">
          <p className="data-view-card-title">Invoice Settings</p>
        </div>
        <br />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Default payment terms*</p>
                <select className="input">
                  <option value="">Select..</option>
                  {Date.map((dateValue, dateIndex) => {
                    return (
                      <option key={dateIndex} value={dateValue.date}>
                        Due within {dateValue.date} days
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="settings-input-message">
                  Does not apply to recurring invoices.
                </p>
                <p className="input-heading">Default Title*</p>
                <input type="text" className="input" placeholder="Title" />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="settings-input-message">
                  The default title for all invice. you can change this on each
                  invoice.
                </p>
                <p className="input-heading">Default Subheading</p>
                <input
                  type="number"
                  className="input"
                  placeholder="Subheading"
                />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="settings-input-message">
                  This will be displayed below the title of each invoice. useful
                  for things like abn numbers.
                </p>
                <p className="input-heading">Default Footer</p>
                <input type="number" className="input" placeholder="Footer" />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="settings-input-message">
                  This will be displayed at the bottom of each invoice.
                </p>
                <p className="input-heading">Default Notes / terms</p>
                <textarea
                  className="textarea"
                  placeholder="Notes / terms"
                  rows="20"
                  cols="40"
                ></textarea>
                <p className="settings-input-message">
                  Appears on each invoice. you can choose to override it when
                  you crate invoice
                </p>
              </div>
            </Grid>
          </Grid>
          <br />
          <p className="input-heading">Select Invoice Template</p>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="Contemporary"
              name="radio-buttons-group"
            >
              <Grid container spacing={2}>
                <Grid item xl={4} lg={4} md={4} sm={4} xs={6}>
                  <div>
                    <img
                      src={ContemporaryImage}
                      className="create-invoice-template-image"
                    />

                    <FormControlLabel
                      value="Contemporary"
                      control={<Radio />}
                      label="Contemporary"
                    />
                  </div>
                </Grid>
                <Grid item xl={4} lg={4} md={4} sm={4} xs={6}>
                  <div>
                    <img
                      src={ClassicImage}
                      className="create-invoice-template-image"
                    />

                    <FormControlLabel
                      value="Classic"
                      control={<Radio />}
                      label="Classic"
                    />
                  </div>
                </Grid>
                <Grid item xl={4} lg={4} md={4} sm={4} xs={6}>
                  <div>
                    <img
                      src={ModernImage}
                      className="create-invoice-template-image"
                    />

                    <FormControlLabel
                      value="Modern"
                      control={<Radio />}
                      label="Modern"
                    />
                  </div>
                </Grid>
              </Grid>
            </RadioGroup>
          </FormControl>
          <Grid container spacing={2}>
            <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Select Company logo</p>
                <label htmlFor="icon-button-file">
                  <Input accept="image/*" id="icon-button-file" type="file" />
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    className="icon-button-file"
                  >
                    <BsPlusLg color="#7C7C7C" size={30} />
                  </IconButton>
                </label>
                <p className="upload-file-requirements">
                  (Upload only png,jpg,pdf)
                </p>
              </div>
            </Grid>
            <Grid item xl={8} lg={8} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Accent Colot</p>
                <Grid container spacing={2}>
                  <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                    <input
                      type="text"
                      className="input"
                      placeholder="#000000"
                    />
                  </Grid>
                </Grid>
                <p className="color-picker-heading">
                  Choose an accent color to use in the invoice
                </p>
              </div>
            </Grid>
          </Grid>
          <p className="settings-invoice-column-heading">
            Invoice Column Settings
          </p>
          <p className="input-heading">
            Edit the titles of the columns on your invoices:
          </p>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Title</p>
                <Grid container spacing={2}>
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="Title"
                        name="radio-buttons-group"
                      >
                        <FormControlLabel
                          value="Title"
                          control={<Radio />}
                          label="Title (Default)"
                        />
                        <FormControlLabel
                          value="Service"
                          control={<Radio />}
                          label="Service"
                        />
                        <div className="setting-radio-main">
                          <FormControlLabel
                            value="other"
                            control={<Radio />}
                            label="Other"
                          />
                          <input type="text" className="input" />
                        </div>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Start date - End date</p>
                <Grid container spacing={2}>
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="Start date - End date"
                        name="radio-buttons-group"
                      >
                        <FormControlLabel
                          value="Start date - End date"
                          control={<Radio />}
                          label="Start date - End date (Default)"
                        />
                        <FormControlLabel
                          value="Date"
                          control={<Radio />}
                          label="Date"
                        />
                        <div className="setting-radio-main">
                          <FormControlLabel
                            value="other"
                            control={<Radio />}
                            label="Other"
                          />
                          <input type="text" className="input" />
                        </div>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Rate</p>
                <Grid container spacing={2}>
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="Rate"
                        name="radio-buttons-group"
                      >
                        <FormControlLabel
                          value="Rate"
                          control={<Radio />}
                          label="Rate (Default)"
                        />
                        <FormControlLabel
                          value="Price"
                          control={<Radio />}
                          label="Price"
                        />
                        <div className="setting-radio-main">
                          <FormControlLabel
                            value="other"
                            control={<Radio />}
                            label="Other"
                          />
                          <input type="text" className="input" />
                        </div>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Amount</p>
                <Grid container spacing={2}>
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="Amount"
                        name="radio-buttons-group"
                      >
                        <FormControlLabel
                          value="Amount"
                          control={<Radio />}
                          label="Amount (Default)"
                        />

                        <div className="setting-radio-main">
                          <FormControlLabel
                            value="other"
                            control={<Radio />}
                            label="Other"
                          />
                          <input type="text" className="input" />
                        </div>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
            </Grid>

            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">
                  Choose which columns on your invoices to hide:
                </p>
                <Grid container spacing={2}>
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <div>
                      <Checkbox
                        {...label}
                        defaultChecked
                        sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                      />
                      <span className="check-box-title">Hide title</span>
                    </div>
                    <div>
                      <Checkbox
                        {...label}
                        defaultChecked
                        sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                      />
                      <span className="check-box-title">
                        Hide Start date - End date
                      </span>
                    </div>
                    <div>
                      <Checkbox
                        {...label}
                        defaultChecked
                        sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                      />
                      <span className="check-box-title">Hide Rate</span>
                    </div>
                    <div>
                      <Checkbox
                        {...label}
                        defaultChecked
                        sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                      />
                      <span className="check-box-title">Hide amount</span>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Button
                className="form-button"
                variant="text"
                onClick={() => navigate(-1)}
              >
                Save Changes
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default InvoiceSetting;
